import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Stepper,
    Step,
    StepLabel,
    Button,
    Box,
    IconButton,
    Grid,
    Stack,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import productService from '../../services/productService';
import SelectProduct from './SendProductComponents/SelectProduct';
import SelectMarketpace from './SendProductComponents/SelectMarketplace';
import AddCategoryAttribute from './SendProductComponents/AddCategoryAttribute';
import { useSelector } from 'react-redux';
import useAlert from '../../hooks/useAlert';
import PreviewProductSend from './SendProductComponents/Preview';
import outWardService from '../../services/outWardService';
import marketplacesService from '../../services/marketplacesService';
import productAttribute from '../../services/productAttribute';
import LoadingSendProductModal from './SendProductComponents/loadingSendProductModal';
import ecommercePlaceService from '../../services/ecommercePlaceService';




const SendProductMarketplace = ({ open, handleClose, productId, productMainId }) => {
    const [activeStep, setActiveStep] = useState(0);

    const [selectedProducts, setSelectedProducts] = useState([]);
    const [selectedPlacesCategory, setSelectedPlacesCategory] = useState({});
    const [marketPlaceName, setMarketPlaceName] = useState(null);
    const [selectedAttributes, setSelectedAttributes] = useState([]);
    const [selectedPlatformType, setSelectedPlatformType] = useState("marketplace");
    const [selectedPlatform, setSelectedPlatform] = useState(null);
    const [allAttribute, setAllAttribute] = useState(null);
    const [selectedVariantProducts, setSelectedVariantProducts] = useState([]);
    const [sendOutwadrProducts, setSendOutwadrProducts] = useState(null)
    const token = useSelector(state => state?.auth?.user?.accessToken?.token);
    const userId = useSelector((state) => state?.auth?.user?.id);
    const [loading, setLoading] = useState(true);
    const [loadingSendProduct, setLoadingSendProduct] = useState(false);
    const [openLoadingModal, setOpenLoadingModal] = useState(false);
    const [sendProductResponse, setSendProductResponse] = useState(null);
    const [sendSelectProductList, setSendSelectProductList] = useState(null);
    const [allAccounts, setAllAccounts] = useState([]);
    const [ecommerceAccounts, setEcommerceAllAccounts] = useState([]);
    const [compleatedProduct, setCompleatedProduct] = useState(null);
    const steps = ['Ürün Bilgileri', 'Pazaryerleri', 'Kategori Ayarları', "Önizle"];
    const {
        showErrorAlertProductSend,
        showSuccessAlertProductSend,
    } = useAlert();


    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };


    function validateAttributes(allAttribute, selectedAttributes) {
        const requiredAttributes = allAttribute.filter(attr => attr?.required && attr?.varianter == false && attr?.slicer != true);
        const selectedAttributeIds = selectedAttributes.map(attr => attr.attribute.id);
        const missingAttributes = requiredAttributes.filter(attr =>
            !selectedAttributeIds.includes(attr.attribute.id)
        );
        // if (missingAttributes.length > 0) {
        //     const missingNames = missingAttributes.map(attr => attr.attribute.name).join(', ');
        //     alert(`Eksik zorunlu özellikler: ${missingNames}. Lütfen seçim yapınız.`);
        //     return false;
        // }

        return true;
    }
    const saveSendProduct = async () => {

        // if (!validateAttributes(allAttribute, selectedAttributes)) {
        //     return;
        // }
        setLoading(true);

        try {
            //atributler kayıt edilmeden önce bir önceki attributler siliniyor

            // const attributes = await productAttribute.fetchProductAttribute(selectedProducts[0].id);
            // console.log("attributes?.data", attributes?.data)
            // const filterProductAttribute = attributes?.data.filter(attrData =>
            //     selectedAttributes.some(selectedAttr =>
            //         selectedAttr.attribute.name === attrData.attributeValue.attribute.mapAttrName
            //     )
            // );

            // console.log("filterProductAttribute", filterProductAttribute)
            // const productAttributesIdsArray = filterProductAttribute.map(attr => attr.id);
            // if (productAttributesIdsArray.length > 0) {
            //     await productAttribute.deleteProductAttributes(productAttributesIdsArray);
            // }
            if (selectedPlatformType != "ecommerce" && marketPlaceName != "Pttavm") {
                const mainData = {
                    productId: selectedProducts[0]?.id,
                    attributeValue: selectedAttributes
                };
                const mainProductData = transformProductDataToList(mainData, userId);
                const variantProductDataList = selectedVariantProducts.map(variant => {
                    const variantData = {
                        productId: variant.id,
                        attributeValue: selectedAttributes
                    };
                    return transformProductDataToList(variantData, userId);
                });

                const finalProductData = [...mainProductData, ...variantProductDataList.flat()];

                if (finalProductData?.length > 0) {
                    await productService.sendProduct(finalProductData, token);
                }

            }


            let ids = [
                ...selectedProducts.map(product => product.id),
                ...selectedVariantProducts.map(variant => variant.id)
            ];
const categoryId=selectedProducts[0].categoryId;
            var response = await productService.getOutwardSendProducts(ids, selectedPlatform, token, selectedPlatformType,categoryId);
            setSendOutwadrProducts(response?.data);
            showSuccessAlertProductSend();
            handleNext();
            setLoading(false);
        } catch {
            showErrorAlertProductSend();
            setLoading(false);
        }

    }
    function transformProductDataToList(rawData, userId) {
        const productAttributeList = rawData.attributeValue.map(attr => {
            const isValueObject = typeof attr.value === 'object';
            return {
                Id: 0,
                ProductId: rawData.productId,
                Varyantible: attr?.attribute?.varianter,
                MarketPlaceId: selectedPlatform,
                CreateDate: new Date().toISOString(),
                UpdateDate: new Date().toISOString(),
                Ia: true,
                AttributeValueId: isValueObject ? parseInt(attr.value.id) : 0,
                AttributeValue: {
                    Id: 0,
                    AttributeId: parseInt(attr.attribute.id),
                    Name: isValueObject ? attr.value.name : attr.value, // String veya nesne durumu
                    MapAttrVName: isValueObject ? attr.value.name : attr.value,
                    MapAttrVId: isValueObject ? attr.value.id : null,
                    CreateDate: new Date().toISOString(),
                    UpdateDate: new Date().toISOString(),
                    Ia: true,
                    Attribute: {
                        Id: 0,
                        UserId: userId,
                        Name: attr.attribute.name,
                        MapAttrId: attr.attribute.id,
                        MapAttrName: attr.attribute.name,
                        CreateDate: new Date().toISOString(),
                        UpdateDate: new Date().toISOString(),
                        Ia: true,
                    },
                },
            };
        });

        return productAttributeList;
    }


    //tümünü yollar
    const sendProductOutward = async () => {
        setLoadingSendProduct(true);
        setOpenLoadingModal(true);
        const requestBody = createRequestBodyAttribute(
            marketPlaceName,
            allAccounts,
            "2024-11-01T13:17:58.526Z",
            "2024-11-16T13:17:58.526Z"
        );
        try {
           
            var response = await outWardService.sendProduct(marketPlaceName, requestBody, token, selectedPlatformType);
            if (response.state == 1) {
                setCompleatedProduct(requestBody.productRD);
            }
            setSendProductResponse(null);
            setSendProductResponse(response);
            setLoadingSendProduct(false);
        } catch(exx) {
           
            setLoadingSendProduct(false);
        }

    }
    //sadece seçileni yollar

    const sendSelectedProductOutward = async (id) => {
        setLoadingSendProduct(true);
        setOpenLoadingModal(true);
        const requestBody = createRequestBodyAttributeSelectedProduct(
            id,
            marketPlaceName,
            allAccounts,
            "2024-11-01T13:17:58.526Z",
            "2024-11-16T13:17:58.526Z"
        );
        try {
            var response = await outWardService.sendProduct(marketPlaceName, requestBody, token, selectedPlatformType);
            if (response.state == 1) {
                setCompleatedProduct(requestBody.productRD);
            }
            setSendProductResponse(null);
            setSendProductResponse(response);
            setLoadingSendProduct(false);
        } catch {
            setLoadingSendProduct(false);
        }

    }

    //bitir butonu işlevi
    const clearProduct = () => {
        setSelectedProducts([]);
        setAllAttribute(null)
        setSelectedVariantProducts([]);
        setSelectedPlatform(null);
        setSelectedPlacesCategory({});
        setMarketPlaceName(null);
        setActiveStep(0);
        handleClose();
    }
    const getStepContent = (step) => {
        switch (step) {
            case 0:
                return (
                    <SelectProduct
                        setSelectedProducts={setSelectedProducts}
                        selectedProducts={selectedProducts}
                        productId={productId}
                        productMainId={productMainId}
                        setSelectedVariantProducts={setSelectedVariantProducts}
                        selectedVariantProducts={selectedVariantProducts}
                    />
                );
            case 1:
                return (

                    <SelectMarketpace
                        selectedPlatformType={selectedPlatformType}
                        setSelectedPlatformType={setSelectedPlatformType}
                        selectedPlatform={selectedPlatform}
                        setSelectedPlatform={setSelectedPlatform}
                        setMarketPlaceName={setMarketPlaceName}
                        selectedProducts={selectedProducts}
                        setSelectedPlacesCategory={setSelectedPlacesCategory}
                    />
                );
            case 2:
                return (
                    <AddCategoryAttribute
                        selectedPlacesCategory={selectedPlacesCategory}
                        marketPlaceName={marketPlaceName}
                        setSelectedAttributes={setSelectedAttributes}
                        setAllAttribute={setAllAttribute}
                        loadingSend={loading}
                        selectedPlatformType={selectedPlatformType}
                    />
                );
            case 3:
                return (
                    <PreviewProductSend
                        selectedProducts={selectedProducts}
                        selectedVariantProducts={selectedVariantProducts}
                        marketPlaceName={marketPlaceName}
                        selectedPlatform={selectedPlatform}
                        selectedAttributes={selectedAttributes}
                        loading={loading}
                        sendSelectedProductOutward={sendSelectedProductOutward}
                        compleatedProduct={compleatedProduct}
                        clearProduct={clearProduct}
                        selectedPlatformType={selectedPlatformType}
                    />
                );
            default:
                return 'Bilinmeyen adım';
        }
    };






    useEffect(() => {

        const fetchAccounts = async () => {
            setLoading(true);
            try {
                const response = await marketplacesService.getMarketPlacesAccountsApi(
                    userId,
                    token
                );
                setAllAccounts(response?.data?.data?.data);
                setLoading(false);
            } catch (err) {
                setError(
                    err.response?.data?.message || "Hesap bilgileri alınırken hata oluştu."
                );
                setLoading(false);
            }

        };

        const fetchAccountsEcommerce = async () => {
            setLoading(true);
            try {
                const response = await ecommercePlaceService.getEcommercePlaceAccountsApi(
                    userId,
                    token
                );
                setEcommerceAllAccounts(response?.data?.data?.data);
                setLoading(false);
            } catch (err) {
                setError(
                    err.response?.data?.message || "Hesap bilgileri alınırken hata oluştu."
                );
                setLoading(false);
            }

        };
        fetchAccounts();
        fetchAccountsEcommerce();
    }, []);

    //  toplu gönderilecek için body
    const createRequestBodyAttribute = (selectedPlaceName, allAccounts, startDate, endDate, page = 0, size = 100) => {
        const marketPlaceSettings = allAccounts
            .filter(account => account.marketPlaceName === selectedPlaceName)
            .map(account => ({
                id: 0,
                userId: account.userId,
                marketPlaceId: account.marketPlaceId || 0,
                marketPlaceName: account.marketPlaceName,
                valueId: account.valueId,
                value: account.value,
                createDate: new Date().toISOString(),
                updateDate: new Date().toISOString(),
                ia: true,
            }));
        const ecommercePlaceSettings = ecommerceAccounts
            .filter(account => account.ecommercePlaceName === selectedPlaceName)
            .map(account => ({
                id: 0,
                userId: account.userId,
                ecommercePlaceId: account.ecommercePlaceId || 0,
                ecommercePlaceName: account.ecommercePlaceName,
                valueId: account.valueId,
                value: account.value,
                createDate: new Date().toISOString(),
                updateDate: new Date().toISOString(),
                ia: true,
            }));
        // const ecommercePlaceSettings = [
        //     {
        //         id: 0,
        //         userId: 0,
        //         ecommerceId: 0,
        //         value: "string",
        //         valueId: "string",
        //         createDate: new Date().toISOString(),
        //         updateDate: new Date().toISOString(),
        //         ia: true,
        //     },
        // ];
        setSendSelectProductList(sendOutwadrProducts);
        return {
            userId: userId,
            marketPlaceSetting: marketPlaceSettings,
            ecommercePlaceSettings: ecommercePlaceSettings,
            startDate: startDate || new Date().toISOString(),
            endDate: endDate || new Date().toISOString(),
            page: page,
            size: size,
            productRD: sendOutwadrProducts
        };
    };
    // seçili olanı göndermek için body
    const createRequestBodyAttributeSelectedProduct = (id, selectedPlaceName, allAccounts, startDate, endDate, page = 0, size = 100) => {
        const marketPlaceSettings = allAccounts
            .filter(account => account.marketPlaceName === selectedPlaceName)
            .map(account => ({
                id: 0,
                userId: account.userId,
                marketPlaceId: account.marketPlaceId || 0,
                marketPlaceName: account.marketPlaceName,
                valueId: account.valueId,
                value: account.value,
                createDate: new Date().toISOString(),
                updateDate: new Date().toISOString(),
                ia: true,
            }));
        const ecommercePlaceSettings = ecommerceAccounts
            .filter(account => account.ecommercePlaceName === selectedPlaceName)
            .map(account => ({
                id: 0,
                userId: account.userId,
                ecommercePlaceId: account.ecommercePlaceId || 0,
                ecommercePlaceName: account.ecommercePlaceName,
                valueId: account.valueId,
                value: account.value,
                createDate: new Date().toISOString(),
                updateDate: new Date().toISOString(),
                ia: true,
            }));
        // const ecommercePlaceSettings = [
        //     {
        //         id: 0,
        //         userId: 0,
        //         ecommerceId: 0,
        //         value: "string",
        //         valueId: "string",
        //         createDate: new Date().toISOString(),
        //         updateDate: new Date().toISOString(),
        //         ia: true,
        //     },
        // ];
        const selectedProduct = sendOutwadrProducts.find(product => product.id === id);
        setSendSelectProductList([selectedProduct]);
        return {
            userId: userId,
            marketPlaceSetting: marketPlaceSettings,
            ecommercePlaceSettings: ecommercePlaceSettings,
            startDate: startDate || new Date().toISOString(),
            endDate: endDate || new Date().toISOString(),
            page: page,
            size: size,
            productRD: [selectedProduct]
        };
    };
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="xl"
            fullWidth
        >
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                Ürün Gönder
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <Stepper activeStep={activeStep} alternativeLabel>
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>

                <Box sx={{ mt: 2, mb: 2 }}>
                    {activeStep === steps.length ? (
                        <Box sx={{ textAlign: 'center' }}>
                            <div>Tüm adımlar tamamlandı</div>
                            <Button onClick={handleReset} sx={{ mt: 2 }}>
                                Baştan Başla
                            </Button>
                        </Box>
                    ) : (
                        <>
                            <Box sx={{ mt: 2, mb: 2 }}>
                                {getStepContent(activeStep)}
                            </Box>

                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Button
                                    disabled={activeStep === 0}
                                    onClick={handleBack}
                                >
                                    Geri
                                </Button>
                                <Stack direction="row" justifyContent="flex-end">
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            if (activeStep === steps.length - 2) {
                                                saveSendProduct();

                                            } else if (activeStep === steps.length - 1 && (marketPlaceName == "Pttavm" ||marketPlaceName == "Shopier"||marketPlaceName == "Etsy"||selectedPlatformType=="ecommerce")) {
                                                sendProductOutward();

                                            } else {
                                                handleNext();
                                            }
                                        }}
                                        sx={{
                                            borderRadius: 2,
                                            marginRight: 1
                                        }}
                                        disabled={activeStep === 0 && selectedProducts.length === 0
                                            || (activeStep === steps.length - 1 && (marketPlaceName != "Pttavm" &&marketPlaceName != "Shopier"&&marketPlaceName != "Etsy"&&selectedPlatformType!="ecommerce") || (loading)

                                            )}
                                    >
                                        {activeStep === steps.length - 1 ? 'Tümünü Gönder' : 'İleri'}
                                    </Button>
                                    {
                                        activeStep === steps.length - 1
                                            ?
                                            <Button
                                                onClick={clearProduct}
                                                variant="contained"
                                                color="primary"
                                                sx={{
                                                    borderRadius: 2
                                                }}
                                            >
                                                Bitir
                                            </Button> : null
                                    }

                                </Stack>
                            </Box>
                        </>
                    )}
                </Box>
            </DialogContent>

            <LoadingSendProductModal
                open={openLoadingModal}
                handleCloseDialog={() => setOpenLoadingModal(false)}
                loadingSendProduct={loadingSendProduct}
                sendProduct={sendSelectProductList}
                sendProductResponse={sendProductResponse}
                marketPlaceName={marketPlaceName}
            />

        </Dialog>
    );
};

export default SendProductMarketplace;